import AdminRoutes from './AdminRoutes';

export default AdminRoutes;
